module.exports = __webpack_public_path__ + "img/fire-block-white.6fcb796d.svg";